// extracted by mini-css-extract-plugin
module.exports = {"container":"EventSnapshotList_container__EoA92","header":"EventSnapshotList_header__3WrBZ","list":"EventSnapshotList_list__2YEGf"};